import styled from 'styled-components';
import { PetalProps } from '../../interfaces';

export const StalkContainer = styled.div<PetalProps>`
height: ${props => props.heigth}%;
width:3px;
background-color: #BEBDBE;


.text{
  p{
    margin-top: 25px;
    margin-left: 6px; 
    width: 15px;
    transform: matrix(0, -1, 1, 0, 0, 0);
    color: #161615;
    font-size: 17px;
    font-weight: 900;
  }
}

`